module.exports = __webpack_public_path__ + "img/arms_1_1.678a9f17.png";